import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import useBenefitMaxDrugStatusSchedule from "./hooks/useBenefitMaxDrugStatusSchedule";

const BenefitMaxDrugStatusSchedule = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectModeParamData,
  
}) => {
  const benefitMaxDrugStatusScheduleData = useBenefitMaxDrugStatusSchedule(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={benefitMaxDrugStatusScheduleData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {benefitMaxDrugStatusScheduleData.screen_title} -{" "}
          <span className="heading-cod">
            {benefitMaxDrugStatusScheduleData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={benefitMaxDrugStatusScheduleData.formFields}
        dropdownValues={benefitMaxDrugStatusScheduleData.dropdownValues}
        paramsData={benefitMaxDrugStatusScheduleData.paramsData}
        updataParamData={benefitMaxDrugStatusScheduleData.updateParamData}
      />
      <ButtonsSection
        ctaButtons={benefitMaxDrugStatusScheduleData.ctaButtons}
      />
      <DisplayTable
        data={benefitMaxDrugStatusScheduleData.data}
        parmKey={benefitMaxDrugStatusScheduleData.parmKey}
        statusKey={benefitMaxDrugStatusScheduleData.statusKey}
        menuOptions={benefitMaxDrugStatusScheduleData.menuOptions}
        tableHeaders={benefitMaxDrugStatusScheduleData.columnDef}
        setRowData={benefitMaxDrugStatusScheduleData.setRowData}
        selectedPriceSchedules={benefitMaxDrugStatusScheduleData.selectedRows}
        setSelectedPriceSchedules={
          benefitMaxDrugStatusScheduleData.setSelectedRows
        }
        selectMode={selectMode}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={benefitMaxDrugStatusScheduleData.first}
          rows={benefitMaxDrugStatusScheduleData.rows}
          totalRecords={benefitMaxDrugStatusScheduleData.totalRecords}
          currentPage={benefitMaxDrugStatusScheduleData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={benefitMaxDrugStatusScheduleData.onPageChange}
        />
      </div>
      {benefitMaxDrugStatusScheduleData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={benefitMaxDrugStatusScheduleData.isConfirmationModalOpen}
          onRequestClose={
            benefitMaxDrugStatusScheduleData.closeConfirmationModal
          }
          onBack={benefitMaxDrugStatusScheduleData.closeConfirmationModal}
          onSave={
            benefitMaxDrugStatusScheduleData.deleteBenefitMaxDrugStatusSchedule
          }
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={benefitMaxDrugStatusScheduleData.setSelectedOption}
        />
      )}
      {benefitMaxDrugStatusScheduleData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={benefitMaxDrugStatusScheduleData.isHideConfirmationModalOpen}
          onRequestClose={
            benefitMaxDrugStatusScheduleData.closeHideConfirmationModal
          }
          onBack={benefitMaxDrugStatusScheduleData.closeHideConfirmationModal}
          onSave={
            benefitMaxDrugStatusScheduleData.hideUnhideBenefitMaxDrugStatusSchedule
          }
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={
            benefitMaxDrugStatusScheduleData.setHideSelectedOption
          }
        />
      )}
    </div>
  );
};

export default BenefitMaxDrugStatusSchedule;